<template>
  <div>
    <div class="linktoac">

      <a
        href=""
        @click.prevent="findmyloc"
        :class="current_loc ? 'activaa' : ''"
        >  <v-icon v-if="showradiocurrent" class="color-check">mdi-radiobox-blank</v-icon>&nbsp;<v-icon v-if="current_loc">mdi-check-outline</v-icon>
        Trouver ma position actuelle sur la carte &nbsp;&nbsp;

        </a  >
      <a
        href=""
        @click.prevent="searchTheLoc"
        :class="current_sloc ? 'activaa' : ''"
        ><v-icon v-if="showradiofind" class="color-check" >mdi-radiobox-blank</v-icon><v-icon v-if="current_sloc">mdi-check-outline</v-icon>&nbsp;Indiquer un autre point de livraison &nbsp;&nbsp;
      </a>
    </div>
    <div class="padingtone" v-show="mapshown">
      <v-card-subtitle v-if="current_loc" class="text-center subtitle-map">
        Nous allons trouver votre position sur la carte
      </v-card-subtitle>
      <v-card-subtitle v-if="current_sloc && fatou" class="text-center subtitle-map">
        Vous pouvez trouver l'endroit le plus proche de votre point livraison à
        l'aide de la barre de recherche <br /> <br>
        Vous pouvez déplacer le curseur sur la carte si vous souhaitez plus de précision
      </v-card-subtitle>
      <v-container v-show="current_sloc">
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field v-if="modou"
              solo
              placeholder="Indiquer votre point de livraison sur la carte"
              v-model="selectzone_livraison"
              id="selectzone_livraison"
              prepend-inner-icon="mdi-map-marker"
            >
            </v-text-field>

            <label for="complement_adress">Merci de nous indiquer la zone de livraison</label>
            <v-text-field
              solo class="complement_adress"
              placeholder="A coté de ...."
              v-model="complement_adress"
              id="complement_adress"

            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-snackbar
              v-model="snackbarIndicationMarker"
              :timeout="timeout_snackbarIndicationMarker"
            >
              {{ text_snackbarIndicationMarker }}

              <template v-slot:action="{ attrs }">
                <v-btn
                    :style="{color:colorinfos.buttonCartColor}"
                  text
                  v-bind="attrs"
                  @click="snackbarIndicationMarker = false"
                >
                  Close
                </v-btn>
              </template>
            </v-snackbar>
          </v-col>
        </v-row>
      </v-container>
      <GmapMap
        ref="mymap"
        :center="positionclient"
        :zoom="16"
        map-type-id="terrain"
        style="width: 100%; height: 400px; "
      >
        <GmapMarker
          :position="positionclient"
          :clickable="true"
          :draggable="true"
          @dragend="updateCoordinates"
        />
      </GmapMap>

      <div class=" card-action-bottom">
                      <v-btn v-show="showpreviousbutton"
                        color="white"   class="btn-cart"
                        @click.prevent="gobackward"
                      > <v-icon>mdi-undo</v-icon> </v-btn>

                      <v-btn type  :disabled="!validloc"
                        color="white" class="btn-cart"
                         @click.prevent="savefindmyloc"
                      >valider</v-btn>
        </div>
    </div>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

export default {
  title: "FindMyLoc",
  components: {},
  props: {
    showpreviousbutton: Boolean,
  },
  watch: {
    yaya: function() {}
  },
  data() {
    return {
      nb_items: 0,
      mapshown: false,
      showradio:true,
      showradiocurrent:true,
      showradiofind:true,
      current_loc: false,
      current_sloc: false,
      validloc: false,
      snackbarIndicationMarker: false,
      text_snackbarIndicationMarker:
        "Vous pouvez déplacer le marqueur pour si vous souhaitez préciser d'avantage votre position.",
      timeout_snackbarIndicationMarker: 10000,
      typeposition : '',
      text_loc: "",
      selectzone_livraison: "",
      complement_adress:"",
      autocomplete_deliverypoint: null,
      zonedeliveryObj: null,
      vm: {
        searchPlace: "",
        location: {}
      },
      options_autocomplete: {
        componentRestrictions: { country: "sn" },
        fields: ["formatted_address", "geometry", "name"],
        origin: null,
        strictBounds: false,
        types: ["geocode", "establishment"]
      },

      dialogus: false,
      yaya: {},
      sommeTotale: 0,
      disabledfinalisation: true,
      stagecardview: 1,
      backupkycform: {
        tel: "",
        complete_name: "",
        remember_me: ""
      },
      datasreported: {},
      positionclient: {
        lat: 10,
        lng: 10
      },
      colorgreen: "#00a65ad4",
      colorred: "#EF323D",

      item_depos: [],
      loading: false,
      zonedepos: []
    };
  },
  computed: {
    state_zonedepos: function() {
      console.log("**COMPUTED** changement state_zonedepos");
      zone_done = [];
      let Oldthis = this;

      _.forEach(Oldthis.zonedepos, function(zone, kr) {
        $zone = zone.properties.Name;
        zone_done.push($zone);
      });
      if (!_.isEmpty(zone_done)) {
        return zone_done;
      }
    },
    google: function() {
      return gmapApi;
    }
  },
  watch: {
    nbarticle: function(val) {
      if (val > 0) {
        this.disabledfinalisation = false;
      } else {
        this.disabledfinalisation = true;
      }
    }
  },
  mounted() {
    console.log("nbarticle done zer", this.nbarticle);
    console.log("<--------------------->");
    console.log("listcart", this.listcart);

    this.nb_items = parseInt(this.nbarticle);
  },
  methods: {
    getAddressData: function(addressData, placeResultData, id) {
      console.log(addressData);
    },
    activeButtonValid(){
        this.validloc = true;
    },
    removeButtonValid(){
        this.validloc = false;
    },
    placeholdervalue() {

    },
    savefindmyloc(){
      console.log('savefindmyloc------>');
      var sendDataLoc = {
        typeposition: this.typeposition,
        location: this.positionclient,
        name_loc: this.selectzone_livraison,
        complement_adress: this.complement_adress,
        selectzone_livraison: this.selectzone_livraison
      };
       this.$emit("getdataloc", sendDataLoc);
    },
    charge_input_depart() {
      let Oldthis = this;
      let input_select_zonelivraison = document.getElementById(
        "selectzone_livraison"
      );

      console.log("nom input", input_select_zonelivraison);

      this.$refs.mymap.$mapPromise.then(() => {
        console.log("on est dannns mapPromise");

        Oldthis.autocomplete_deliverypoint = new google.maps.places.Autocomplete(
          input_select_zonelivraison,
          Oldthis.options_autocomplete
        );
        Oldthis.autocomplete_deliverypoint.addListener(
          "place_changed",
          function() {

            let place = Oldthis.autocomplete_deliverypoint.getPlace();

            Oldthis.selectzone_livraison = place.name;
            Oldthis.zonedeliveryObj = { place };

            Oldthis.positionclient.lat = Oldthis.zonedeliveryObj.place.geometry.location.lat();
            Oldthis.positionclient.lng = Oldthis.zonedeliveryObj.place.geometry.location.lng();
            Oldthis.snackbarIndicationMarker = true;

            Oldthis.activeButtonValid();

          }
        );
      });
    },

    gobackward(){
      //this.fillkycbackup();

          console.log('going backward',this.kyc_datas);
          this.$emit('previous', {back:'findmyloc'});
          //this.$parent.activekyc = false;
    },

    showmethemap() {
      this.mapshown = true;
    },
    findmyloc() {
      this.showradiocurrent = false;
      this.showradiofind = true;
      this.removeButtonValid();
      this.typeposition = 'current_position';
      this.getCurrentPosition();
      this.current_loc = true;
      this.current_sloc = false;
    },
    searchTheLoc() {
      this.showradiofind = false;
      this.showradiocurrent = true;

      this.removeButtonValid();
      this.current_sloc = true;
      this.mapshown = false;
      this.current_loc = false;
      this.typeposition = 'findinmap';

      console.log("searchTheLoc----->");
      if (this.current_sloc) {
        this.charge_input_depart();
      }
      // pour permettre au bouton de validation de s'afficher
      this.validloc = true

      this.showmethemap();
    },

    updateCoordinates(location) {
      //console.log('updateCoordinates',location.latLng)
      this.positionclient = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
      this.datasreported.current_position = this.positionclient;
    },
    validationCommand() {
      //this.dialogus = false
      this.$emit("datasFromCartbox", this.datasreported);
    },
    RemoveOnCart(article) {
      console.log("RemoveOnCart", article);
      this.$emit("articleToRemove", {
        id: article.id
      });
    },
    getCurrentPosition() {
      let Oldthis = this;
      this.$getLocation({
        enableHighAccuracy: true
      })
        .then(coordinates => {
          console.log("trouver la position dat ");
          this.positionclient.lat = coordinates.lat;
          this.positionclient.lng = coordinates.lng;
          Oldthis.datasreported.gotcoordinate = true;
          Oldthis.datasreported.current_position = coordinates;
          Oldthis.showmethemap();
          Oldthis.activeButtonValid();
          //console.log(coordinates, "<=== vous avez bien été géolocalisé");
        })
        .catch(error => {
          alert(
            "Nous avons besoin de vos coordonnées GPS pour faciliter la livraison. Merci de cliquer sur autoriser"
          );
        });
    }
  }
};
</script>

<style >
.card-action-bottom{
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 25px;
}
.btn-cart{
    margin-top: 10px;
    margin-bottom: 10px;
}

.linktoac > a:link {
  text-decoration: none;
  color: #fafafa;
  }


.linktoac > a:visited { text-decoration: none; }


.linktoac > a:hover { text-decoration: none; }


.linktoac > a:active { text-decoration: none; }

</style>



// WEBPACK FOOTER //
// src/components/pieces/findmyloc.vue